export function File(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="18"
        height="22"
        viewBox="0 0 18 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.8394 0.800003C11.9877 0.800003 13.048 1.41532 13.6178 2.41236L16.7784 7.94349C17.0547 8.427 17.2 8.97425 17.2 9.53113V18C17.2 19.7673 15.7674 21.2 14 21.2H4.00005C2.23274 21.2 0.800049 19.7673 0.800049 18V4C0.800049 2.23269 2.23274 0.800003 4.00005 0.800003H10.8394ZM10.8394 3.2H4.00005C3.55822 3.2 3.20005 3.55818 3.20005 4V18C3.20005 18.4418 3.55822 18.8 4.00005 18.8H14C14.4419 18.8 14.8 18.4418 14.8 18V9.53113C14.8 9.39191 14.7637 9.2551 14.6946 9.13422L11.534 3.60309C11.3916 3.35383 11.1265 3.2 10.8394 3.2ZM12 14.8C12.6628 14.8 13.2 15.3373 13.2 16C13.2 16.6627 12.6628 17.2 12 17.2H6.00005C5.33731 17.2 4.80005 16.6627 4.80005 16C4.80005 15.3373 5.33731 14.8 6.00005 14.8H12ZM12 10.8C12.6628 10.8 13.2 11.3373 13.2 12C13.2 12.6627 12.6628 13.2 12 13.2H6.00005C5.33731 13.2 4.80005 12.6627 4.80005 12C4.80005 11.3373 5.33731 10.8 6.00005 10.8H12ZM10 6.8C10.6628 6.8 11.2 7.33726 11.2 8C11.2 8.66274 10.6628 9.2 10 9.2H6.00005C5.33731 9.2 4.80005 8.66274 4.80005 8C4.80005 7.33726 5.33731 6.8 6.00005 6.8H10Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
